const https = location.protocol === 'https';

export const environment = {
  production: false,
  version: '4.0',
  copyright: '2021 Schneider Electric.',
  legalUrl: 'https://www.google.com',
  releaseDate: '2021-08-21 17:30',
  log: true,
  rxjsLog: false,
  application: {
    name: 'wlmux',
    logoUrl: '',
    companyLogo: '',
  },
  oAuthConfig: {
    get issuer(): string {
      return location.protocol === 'https' ? 'https://localhost:44335' : 'https://localhost:44335';
    },
    clientId: 'WLMUX_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'openid profile email WLMUX',
    showDebugInformation: true,
    oidc: true,
    requireHttps: true,
    response_type: 'code',
    get redirectUri(): string {
      return location.protocol === 'https'
        ? 'http://localhost:4200/signin-oidc'
        : 'http://localhost:4200/signin-oidc';
    },
  },
  apis: {
    default: {
      get url(): string {
        return location.protocol === 'https'
          ? 'https://localhost:44327'
          : 'https://localhost:44327';
      },
    },
    interfaces: {
      get url(): string {
        return location.protocol === 'https'
          ? 'https://localhost:44327'
          : 'https://localhost:44327';
      },
    },
    config: {
      url: 'https://localhost:44327/api/settings/frontend',
    },
  },
  localization: {
    defaultResourceName: 'wlmux',
    forcedDateFormat: undefined,
    forcedHourFormat: undefined,
    defaultLocale: 'en-GB',
    availableLocales: ['es', 'en-GB', 'tr', 'it', 'zh-CN'],
  },
  gis: {
    glUrl: 'https://map.qa.fe.wlm.one',
    raster: {
      tiles: [
        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
        'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
        'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
      ],
      tilesSet: null,
      size: 256,
    },
    map: {
      center: [52.67, -0.46],
      zoom: 10,
    },
    coordinatesSystem: 'latLong',
  },
  headers: {
    spinnerHeader: 'X-Loading-Spinner',
  },
  defaultCacheDurationMinutes: 1440,
  endDateLowerEqual: false,
  increaseEndDate: true,
  minAllowedYear: 1700,
  uomConversionDecimals: 15,
  uomMinPositionsToKeepPrecision: 6,
  useMultitenant: false,
  chartDisplaySymbolThreshold: 3000,
  maxDecimalPositions: 4,
  maxDecimalPositionsForGreatNumber: 2,
  greatNumberToChangePrecision: 1000,
  maxOverflowToShowExtendedTooltip: 200,
  maxGeoJsonSize: 700 * 1024 * 1024,
  maxShapeFileSize: 2.5 * 1024 * 1024 * 1024,

  cards: {
    telemetry: {
      titleField: 'description',
      subtitleField: 'id',
    },
    hierarchy: {
      titleField: 'name',
      subtitleField: 'id',
    },
  },
};
